// var jQuery = require("jquery");
// require("@accessible360/accessible-slick");

// document.addEventListener( 'DOMContentLoaded', function() {
// 	jQuery('.testimonial-slider--wrapper').slick({
// 		dots: true,
// 		infinite: false,
// 		adaptiveHeight: true,
// 	});
// });